import styled from "styled-components";

export const Column = styled.div`
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    box-sizing: border-box;
    max-width: 100%;
    margin-bottom: 1rem;
`;


export const Columns = styled.div`
    display: flex;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    flex-wrap: wrap;
    justify-content: stretch;
`;

export const UnevenColumns = styled(Columns)`
    >${Column} {
        flex-shrink: initial;
        flex-basis: initial;
    }
`;
